import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const avatarSizes = { small: 32, normal: 40, medium: 48, bigger: 64 };

export const mainIconStyle = (theme: Theme, noBorder: boolean) => css`
  width: 100%;
  height: 100%;
  border-radius: ${theme.borderRadius.circle};
  border: ${noBorder ? '0' : '1px'} solid ${theme.palette.ghost.mediumContrast};
`;
export const root = (theme: Theme) => css`
  position: relative;
  display: flex;
  border-radius: ${theme.borderRadius.circle};
  background: ${theme.palette.background.main};
`;

export type AvatarSizes = '32' | '40' | '48' | '64';
export const size = (px: AvatarSizes) => css`
  width: ${px}px;
  height: ${px}px;
  font-size: ${px}px;
`;

export const noPlaceholderBackground = css`
  background: none;
`;
export const image = (theme: Theme) => css`
  font-size: ${theme.fontSize.xxxs};
`;

export const subIcon = (theme: Theme) => css`
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  overflow: hidden;

  border-radius: ${theme.borderRadius.circle};
  right: -8px;
  bottom: -8px;
  height: 24px;
  width: 24px;
  font-size: 24px;
`;

export const spacingRight = (theme: Theme) => css`
  margin-right: ${theme.spacing[8]};
`;

export const children = css`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
